"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _UI5KWBYVcjs = require('../__chunks/UI5KWBYV.cjs');


exports.PortalContext = _UI5KWBYVcjs.PortalContext;
